import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Line from '../../../components/gfx/Line';

const SETTINGS = {
    maxSkills: 20,
    minCount: 2,
};

class SkillStats extends PureComponent {
    static propTypes = {
        // we assume sorted skillsLine
        skills: PropTypes.array,
    };

    renderSkillRow(skill, totalCount) {
        const activePercentage = `${(skill.activeCount / totalCount) * 100}%`;
        const passivePercentage = `${
            ((skill.count - skill.activeCount) / totalCount) * 100
        }%`;

        return (
            <tr key={skill.name}>
                <td className="u-word-break">{skill.name}</td>
                <td className="u-no-break">{skill.count} stk</td>
                <td className="u-hide-lt768" width="60%">
                    <Line color="u-bg-primary-blue" width={activePercentage} />
                    <Line
                        color="u-bg-secondary-blue"
                        width={passivePercentage}
                    />
                </td>
            </tr>
        );
    }

    renderToFew() {
        return (
            <div id="empty-skills">
                Dere har for få følgere med interesseprofil akkurat nå til at vi
                kan vise mer informasjon.
            </div>
        );
    }

    renderSkillList(skills) {
        const maxCount = skills[0].count;
        const skillRows = skills.map((skill) =>
            this.renderSkillRow(skill, maxCount)
        );

        return (
            <table className="data-table">
                <tbody>{skillRows}</tbody>
            </table>
        );
    }

    render() {
        const skills = this.props.skills
            .slice(0, SETTINGS.maxSkills)
            .filter((skill) => skill.count > SETTINGS.minCount);

        return (
            <React.Fragment>
                <div className="grid t-grid u-hide-lt768">
                    <div className="grid__unit u-r-size1of2">
                        <div className="form-grid">
                            <div className="form-grid__unit form-grid__unit--g0 u-pr0">
                                <Line color="u-bg-primary-blue" width="20px" />
                            </div>
                            <div className="form-grid__unit form-grid__unit--g1">
                                <p>
                                    Aktive kandidater
                                    <br />
                                    <span className="u-d1 u-stone">
                                        (høy aktivitet på FINN)
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="grid__unit u-r-size1of2">
                        <div className="form-grid">
                            <div className="form-grid__unit form-grid__unit--g0 u-pr0">
                                <Line
                                    color="u-bg-secondary-blue"
                                    width="20px"
                                />
                            </div>
                            <div className="form-grid__unit form-grid__unit--g1">
                                <p>
                                    Passive kandidater
                                    <br />
                                    <span className="u-d1 u-stone">
                                        (lav aktivitet på FINN, har ikke søkt
                                        stillinger den siste tiden)
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {skills.length > 0
                    ? this.renderSkillList(skills)
                    : this.renderToFew()}
            </React.Fragment>
        );
    }
}

export default SkillStats;
